import React        from 'react';
import PropTypes    from "prop-types";
import ReloadHelper from '../../utils/ReloadHelper';

class ActionAnimation extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			showAnimation: false,
			animation:     "url('" + this.props.animation + "?v=" + new Date().valueOf() + "')",
		};

		this.onClick = this.onClick.bind(this);
	}

	componentDidMount() {
		this.setState({animation: "url('" + this.props.animation + "?v=" + new Date().valueOf() + "')"});
	}

	onClick(e) {
		if (this.props.animation) {
			this.setState({showAnimation: true}, () => {
				setTimeout(() => {
					this.onClk(e);
				}, 1000);
			});
		} else {
			this.onClk(e);
		}
	}

	onClk(e) {
		if (typeof this.props.onClick === "function") {
			this.props.onClick();
		}
		ReloadHelper.reload(this.props.link, e);
	}

	render() {
		if (this.props.animation) {
			return (
				<div className={this.props.className}>
					<span className="animation-link" style={{backgroundImage: this.state.animation, opacity: this.state.showAnimation ? 1 : 0}}/>
					<span className="animation-link" onClick={this.onClick} style={{opacity: this.state.showAnimation ? 0 : 1 }}/>
				</div>
			);
		}

		return (
			<div className={this.props.className}>
				<span className="animation-link" onClick={this.onClick} />
			</div>
		);
	}
}

ActionAnimation.propTypes = {
	onClick:   PropTypes.onClick,
	link:      PropTypes.string.isRequired,
	className: PropTypes.string.isRequired,
	animation: PropTypes.string,
};

ActionAnimation.defaultProps = {
	animation: ""
};

export default ActionAnimation;